(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PaisDetailController', PaisDetailController);

    PaisDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pais', 'Region'];

    function PaisDetailController($scope, $rootScope, $stateParams, previousState, entity, Pais, Region) {
        var vm = this;

        vm.pais = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:paisUpdate', function(event, result) {
            vm.pais = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
